module.exports = __webpack_public_path__ + "static/img/7.9d06715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/7.png
// module id = ar9N
// module chunks = 10